import { REGEX_RULES } from 'constants/regexRules';


export const normalizeToTwoDigits = (rawValue: string, maxValue: number): number => Math.min(
  maxValue, Number(rawValue.replace(REGEX_RULES.nonNumeric, '').slice(0, 2)),
);
